module.exports = __webpack_public_path__ + "img/ValidationReport_7.6453f07b.jpg";